import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UploadDragAndDrop from '../uploadDragAndDrop/uploadDragAndDrop';
import UploadS3DragAndDrop from '../uploadS3DragAndDrop/uploadS3DragAndDrop';
import Label from '../../atoms/label/label';
import FormValidation from '../../atoms/formEnums/formValidation';
import { mapDispatchToProps } from '../../../store/externalCalls/api/uploadFilesApi';
import Video from '../../atoms/video/video';
import InputText from '../../atoms/inputText/inputText';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import './formMultipleUpoloadAsync.scss';
import { IconType } from '../../atoms/icon/icon';
import { encrypt } from '../../../utils/credentialsEncryption';
import UploadGCSDragAndDrop from '../uploadGCSDragAndDrop/uploadGCSDragAndDrop';
const FormMultipleUploadAsync = (props) => {
  const {
    id,
    validation,
    label,
    helpText,
    fileType,
    value,
    defaultInputValue,
    onChange,
    onUpload,
    onCompleted,
    onError,
    onCanceled,
    storageProvider
  } = props;

  const [fileList, setFileList] = useState([]);
  const childRefs = useRef([]);
  const videochildRefs = useRef([]);
  const uploadRef = useRef();

  const updateChilds = (newFileList) => {
    newFileList.forEach((file, index) => {
      // videochildRefs.current[index].updateValue(file.publicFileUrl);
      childRefs.current[index].updateValue(file.fileName);
    });
  };

  const handlerUploaded = (event, file) => {
    
    

    const { uploadURL } = file;
    const publicFolder = uploadURL.substr(uploadURL.lastIndexOf('/'));
    const extension = event.extension;
    const fileName = publicFolder.substr(1);
    const publicFileUrl = `${process.env.REACT_APP_BACKEND_URL}storage/app/video${publicFolder}${publicFolder}.${extension}`;
    const newFileList = [
      ...fileList,
      {
        id: event.id,
        publicFileUrl,
        publicFileName: fileName + '.' + extension,
        
        fileName: defaultInputValue === '' ? '' : defaultInputValue + (fileList.length + 1),
      },
    ];

    setFileList(newFileList);
    onChange({ target: { value: newFileList } });
  };
  const handlerUploadedS3 = (event, file,data) => {
    const { uploadURL } = ' ';
    const extension = event.extension;
    const publicFileUrl = `${data.url}`;
    const newFileList = [
      ...fileList,
      {
        id: event.id,
        publicFileUrl,
        fileName: defaultInputValue === '' ? '' : defaultInputValue + (fileList.length + 1),
        publicFileName: data.videoData.filename
      },
    ];
    setFileList(newFileList);
    onChange({ target: { value: newFileList } });
  };

  const handlerUploadedGCS = (event, file,data) => {
    const { uploadURL } = ' ';
    const extension = event.extension;
    const publicFileUrl = `${data.url}`;
    const newFileList = [
      ...fileList,
      {
        id: event.id,
        publicFileUrl,
        fileName: defaultInputValue === '' ? '' : defaultInputValue + (fileList.length + 1),
        publicFileName: data.videoData.filename
      },
    ];
    setFileList(newFileList);
    onChange({ target: { value: newFileList } });
  };

  const handlerChangeName = (event, indexFile) => {
    const newFileList = [...fileList];
    newFileList[indexFile].fileName = event.target.value;
    setFileList(newFileList);
    onChange({ target: { value: newFileList } });
  };

  const handlerRemoveItem = (indexFile) => {
    const newFileList = [...fileList];

    const elementsToRemove = newFileList.splice(indexFile, 1);
    setFileList(newFileList);
    updateChilds(newFileList);
    onChange({ target: { value: newFileList } });
    uploadRef.current.removeBackgroundFile(elementsToRemove[0].id);
  };

  const handlerOrder = (i, toRight) => {
    const fileListToOrder = [...fileList];
    const nextPosition = toRight ? i + 1 : i - 1;

    fileListToOrder.splice(nextPosition, 0, fileListToOrder.splice(i, 1)[0]);
    setFileList(fileListToOrder);
    updateChilds(fileListToOrder);
    onChange({ target: { value: fileListToOrder } });
  };

  useEffect(() => {
    if (Array.isArray(value)) setFileList(value);
  }, [value]);

  return (
    <div className={`form-group row text-${validation} form-multiple-upload-async`}>
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}        
      <div className="col-sm-8">
        <div className="row">
          { fileList.map((file, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`formMultipleUpload-${i}`} className="col-md-3 form-multiple-upload-async__item">
              <div className="form-multiple-upload-async__container">
                <div className="form-multiple-upload-async__video">
                  <div className="form-multiple-upload-async__video-center">
                    {<Video src={file.publicFileUrl} />}
                  </div>
                  { i > 0
                    && (
                    <Button
                      id={`${id}-${i}-leftButton`}
                      type={ButtonType.Button}
                      className="form-multiple-upload-async__order"
                      theme={ButtonTheme.Link}
                      icon={IconType.ARROW_LEFT}
                      onClick={() => handlerOrder(i, false)}
                    />
                    )}
                  { i < fileList.length - 1
                    && (
                    <Button
                      id={`${id}-${i}-rightButton`}
                      type={ButtonType.Button}
                      className="form-multiple-upload-async__order form-multiple-upload-async__order--right"
                      theme={ButtonTheme.Link}
                      icon={IconType.ARROW_RIGHT}
                      onClick={() => handlerOrder(i, true)}
                    />
                    )}
                  <div className="form-multiple-upload-async__video-operations">
                    <Button
                      id={`${id}-${i}-removeButton`}
                      type={ButtonType.BUTTON}
                      theme={ButtonTheme.LINK}
                      onClick={() => handlerRemoveItem(i)}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              </div>
              <div className="mt-2 form-multiple-upload-async__file-name">{file.publicFileName}</div>
              <InputText
                id={`${id}-${i}-input`}
                ref={(el) => { childRefs.current[i] = el; }}
                name={`file-${i}`}
                placeholder="Camera name"
                value={file.fileName}
                limitSpecialCharacters
                onChange={(e) => handlerChangeName(e, i)}
              />
            </div>
          ))}

          <div className="col-md-3 form-multiple-upload-async__item">
            
            { storageProvider === 'ownS3' ? 
            
            <UploadS3DragAndDrop
            id={`${id}-uploadS3DragAndDrop`}
            ref={uploadRef}
            className="form-multiple-upload-async__upload-component"
            onError={onError}
            onUpload={onUpload}
            onUploaded={handlerUploadedS3}
            onCompleted={onCompleted}
            onCanceled={onCanceled}
            fileType={fileType}
            numberOfFiles={32}
            enableManyTimes
          /> :

            storageProvider === "ownGCS" ? 

            <UploadGCSDragAndDrop 
              id={`${id}-uploadGCSDragAndDrop`}
              ref={uploadRef}
              className="form-multiple-upload-async__upload-component"
              onError={onError}
              onUpload={onUpload}
              onUploaded={handlerUploadedGCS}
              onCompleted={onCompleted}
              onCanceled={onCanceled}
              fileType={fileType}
              numberOfFiles={32}
              enableManyTimes
            
            />


            :
          
          <UploadDragAndDrop
              id={`${id}-uploadDragAndDrop`}
              ref={uploadRef}
              className="form-multiple-upload-async__upload-component"
              onError={onError}
              onUpload={onUpload}
              onUploaded={handlerUploaded}
              onCompleted={onCompleted}
              onCanceled={onCanceled}
              fileType={fileType}
              numberOfFiles={32}
              enableManyTimes
            />
          
          }
            
          </div>
        </div>
      </div>
    </div>
  );
};

FormMultipleUploadAsync.propTypes = {
  /**
   * Id of upload async component
   */
  id: PropTypes.string,
  /**
   * Select form status, it is a FormValidation enum
   */
  validation: PropTypes.oneOf(Object.values(FormValidation)),
  /**
   * Name of input attribute
   */
  label: PropTypes.string,
  /**
   * Input help text
   */
  helpText: PropTypes.string,
  /**
   * value resource reference
   */
  value: PropTypes.arrayOf(Object),
  /**
   * Error event function
   */
  onError: PropTypes.func,
  /**
   * Fired when a the form values are changed.
   */
  onChange: PropTypes.func,
  /**
   * Fired when upload starts
   */
  onUpload: PropTypes.func,
  /**
   * Fired when all uploads are copmlete
   */
  onCompleted: PropTypes.func,
  /**
   * Fierd when all uploads are caceled
   */
  onCanceled: PropTypes.func,
  /**
   * Format of the accepted files
   */
  fileType: PropTypes.arrayOf((PropTypes.string)),
  /**
   * Default value for the input field
   */
  defaultInputValue: PropTypes.string,
};

FormMultipleUploadAsync.defaultProps = {
  id: '',
  validation: FormValidation.PENDING,
  label: '',
  helpText: '',
  fileType: '',
  defaultInputValue: '',
  value: [],
  onChange: () => {},
  onError: () => {},
  onUpload: () => {},
  onCompleted: () => {},
  onCanceled: () => {},
};

export default connect(null, mapDispatchToProps)(FormMultipleUploadAsync);
